import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useInfluencer } from '../../hooks/useInfluencer';
import { Button } from '@/components/ui/button';
import { ChevronLeft } from 'lucide-react';
import ProfileHeader from '@/components/influencer-profile/ProfileHeader';
import InfluencerKeyMetrics from '@/components/influencer-profile/InfluencerKeyMetrics';
import ContactInformation from '@/components/influencer-profile/ContactInformation';
import Collaborations from '@/components/influencer-profile/Collaborations';
import PaymentsHistory from '@/components/influencer-profile/PaymentsHistory';

export const InfluencerProfileView: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const { data: influencer, isLoading, error, refetch } = useInfluencer(id);

  if (isLoading) {
    return (
      <div className="w-full bg-gray-50">
        <div className="flex justify-center items-center h-96">Loading...</div>
      </div>
    );
  }

  if (error || !influencer) {
    return (
      <div className="w-full bg-gray-50">
        <div className="flex flex-col items-center h-96 justify-center">
          <div className="text-red-500 mb-4">Influencer not found.</div>
          <Button variant="outline" onClick={() => navigate('/')}>
            <ChevronLeft className="mr-1" /> Back to Dashboard
          </Button>
        </div>
      </div>
    );
  }

  const handleUpdated = () => {
    refetch();
  };

  return (
    <div className="w-full bg-gray-50 overflow-x-hidden">
      <div className="max-w-8xl mx-auto py-10 px-4 space-y-8">
        {/* Profile Header */}
        <ProfileHeader influencer={influencer as any} onUpdated={handleUpdated} />

        {/* Main Content Grid */}
        <div className="grid grid-cols-1 xl2:grid-cols-[70%_1fr] gap-4">
          {/* Main Content - Left Side */}
          <div className="min-w-0 space-y-8">
            <InfluencerKeyMetrics influencer={influencer as any} />
            <Collaborations influencerId={influencer.id} />
            <PaymentsHistory influencerId={influencer.id} />
          </div>

          {/* Sidebar - Right Side */}
          <div className="min-w-0 space-y-4">
            <ContactInformation influencer={influencer as any} />
          </div>
        </div>
      </div>
    </div>
  );
};
